(function() {
	'use strict';

	angular.module('masterApp').controller('StockDialogController',
			StockDialogController);

	StockDialogController.$inject = [ '$timeout', '$scope', '$stateParams',
			'$uibModalInstance', 'DataUtils', 'entity', 'Stock', 'GLOBAL_URL',
			'$state', '$http', '$filter', 'CommonService', 'MASTER_CONSTANT' ];

	function StockDialogController($timeout, $scope, $stateParams,
			$uibModalInstance, DataUtils, entity, Stock, GLOBAL_URL, $state,
			$http, $filter, CommonService, MASTER_CONSTANT) {
		var vm = this;
		vm.lstOffice = CommonService.query({
			masterurl : 'get-all-office'
		});
		vm.lstArea = CommonService.query({
			masterurl : 'area'
		});
		// vm.stock.area.areaCode = vm.lstArea[0].areaCode;
		vm.lstTransportType = CommonService.query({
			masterurl : 'transport-type'
		});
		vm.lstTypeStock = MASTER_CONSTANT.typeStock
		vm.stock = entity;
		vm.clear = clear;
		vm.byteSize = DataUtils.byteSize;
		vm.openFile = DataUtils.openFile;
		vm.save = save;
		vm.checkcreat = false;
		vm.isSaving = false;
		if (vm.stock.stockId != null || vm.stock.stockId != undefined) {
			vm.checkcreat = true;
			vm.stock.isExit = true;
		} else {
			vm.stock.isExit = false;
			vm.stock.beginDate = new Date();
			// vm.stock.endDate = new Date();
			vm.stock.status = "0";
		}
		if (vm.stock.endDate != null || vm.stock.endDate != undefined) {
			vm.statusEnd = true;
		} else {
			vm.statusEnd = false;
		}
		$timeout(function() {
			angular.element('.form-group:eq(1)>input').focus();
		});

		function clear() {
			$uibModalInstance.dismiss('cancel');
		}

		function save() {
			$scope.clearMessage();
			vm.isSaving = true;
			if (vm.statusEnd != true) {
				vm.stock.endDate = null;
			}
			if (vm.stock.isExit == true) {
				Stock.update(vm.stock, function(result) {
					$scope.$emit('masterApp:stockUpdate', result);
					$uibModalInstance.close(result);
					vm.isSaving = false;
				}, function(error) {
					vm.isSaving = false;
				});
			} else {
				Stock.save(vm.stock, function(result) {
					$scope.$emit('masterApp:stockUpdate', result);
					$uibModalInstance.close(result);
					vm.isSaving = false;
				}, function(error) {
					vm.isSaving = false;
				});
			}
		}

		function onSaveSuccess(result) {
			$scope.$emit('masterApp:stockUpdate', result);
			$uibModalInstance.close(result);
			vm.isSaving = true;
		}

		function onSaveError() {
			vm.isSaving = false;
		}
		vm.openFromDate = function() {
			vm.popupFromDate.opened = true;
		};
		vm.openToDate = function() {
			vm.popupToDate.opened = true;
		};
		$scope.formats = [ 'dd-MMMM-yyyy', 'yyyy/MM/dd', 'dd/MM/yyyy',
				'shortDate' ];
		$scope.format = $scope.formats[2];
		$scope.altInputFormats = [ 'dd/MM/yyyy' ];

		vm.popupFromDate = {
			opened : false
		};

		vm.popupToDate = {
			opened : false
		};
		vm.dateOptions = {
		// maxDate: new Date()
		};
		vm.validateDates = function() {
			$scope.clearMessage();

			var currentDate = new Date();
			var toDate = moment($scope.vm.stock.endDate, "DD/MM/YYYY");
			var fromDate = moment($scope.vm.stock.beginDate, "DD/MM/YYYY");
			if (toDate.diff(fromDate) < 0) {
				vm.checkDate = true;
				$scope
						.addAlert(
								'Vui lòng chọn Ngày bắt đầu lớn hơn hoặc bằng Ngày kết thúc.',
								'error');
			} else {
				vm.checkDate = false;
			}
		};

	}
})();
